export type AppView = "train" | "insights" | "history" | "history-detail" | "profile";
export type PrimaryView = Exclude<AppView, "history-detail">;

export function primaryViewFor(view: AppView): PrimaryView {
  return view === "history-detail" ? "history" : view;
}

export function isPrimaryViewActive(view: AppView, primaryView: PrimaryView): boolean {
  return primaryViewFor(view) === primaryView;
}
